module.exports = __webpack_public_path__ + "static/media/copied_icon.18e9dda3.svg";